<div ngbDropdown container="body">
	<i data-testid="SUBSYS2_RECEIVEDLIST_ACTION_CLONE" class="material-icons action"
		title="{{ labels.RECEIVED_ACTION_COMPONENT_CLONE }}" [ngClass]="{'disabled': isReadonly }"
		(click)="openCloneModal()">content_copy</i>
	<i data-testid="SUBSYS2_RECEIVEDLIST_ACTION_SEE" class="material-icons action"
		title="{{ labels.RECEIVED_ACTION_COMPONENT_SEE_MORE }}" (click)="openDetailModal()">vertical_split</i>
	<i data-testid="SUBSYS2_RECEIVEDLIST_ACTION_DELETE" class="material-icons action"
		title="{{ labels.RECEIVED_ACTION_COMPONENT_DELETE }}" [ngClass]="{'disabled': isReadonly }"
		(click)="openDeleteModal()">delete_outline</i>
</div>